import { Skeleton, Button } from "@heroui/react";
import { Link } from "@tanstack/react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";
import IrrigationSystemForm from "./IrrigationSystemForm";

function IrrigationSystemEditor({
    irrigationSystemId,
}: {
    irrigationSystemId?: string;
}) {
    const { t } = useTranslation();
    const { fieldId, fieldQuery, geometryQuery } = useFieldDashboard() ?? {};
    const fieldBoundary = useMemo(() => {
        return geometryQuery?.data?.field;
    }, [geometryQuery?.data?.field]);

    if (!fieldId) {
        return <Skeleton className="h-4 w-1/2" />;
    }

    return (
        <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-row gap-2 items-center px-2">
                <Button
                    size="sm"
                    variant="light"
                    as={Link}
                    to="/dashboard/fields/$fieldId/setup/irrigation-system"
                    params={
                        {
                            fieldId: String(fieldId),
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        } as any
                    }
                    startContent={<FontAwesomeIcon icon={faChevronLeft} />}
                >
                    {t("back", { ns: "common" })}
                </Button>
                <p className="text-sm font-semibold">
                    {irrigationSystemId
                        ? t("irrigation_system.edit_irrigation_system", {
                              ns: "setup",
                          })
                        : t("irrigation_system.add_irrigation_system", {
                              ns: "setup",
                          })}
                </p>
            </div>
            <IrrigationSystemForm
                fieldId={fieldId}
                growerId={fieldQuery?.data?.grower}
                fieldBoundary={fieldBoundary}
                irrigationSystemId={irrigationSystemId}
            />
        </div>
    );
}

export default IrrigationSystemEditor;
